import type { GenericLanguages } from '@payloadcms/translations'

export const i18n: Partial<GenericLanguages> = {
  ar: {
    label: 'العنوان {{headingLevel}}',
  },
  az: {
    label: 'Başlıq {{headingLevel}}',
  },
  bg: {
    label: 'Заглавие {{headingLevel}}',
  },
  cs: {
    label: 'Nadpis {{headingLevel}}',
  },
  da: {
    label: 'Overskrift {{overskriftNiveau}}',
  },
  de: {
    label: 'Überschrift {{headingLevel}}',
  },
  en: {
    label: 'Heading {{headingLevel}}',
  },
  es: {
    label: 'Encabezado {{headingLevel}}',
  },
  et: {
    label: 'Pealkiri {{headingLevel}}',
  },
  fa: {
    label: '[SKIPPED]',
  },
  fr: {
    label: 'En-tête {{headingLevel}}',
  },
  he: {
    label: 'כותרת {{רמת כותרת}}',
  },
  hr: {
    label: 'Naslov {{headingLevel}}',
  },
  hu: {
    label: 'Címsor {{headingLevel}}',
  },
  is: {
    label: 'Fyrirsögn {{headingLevel}}',
  },
  it: {
    label: 'Intestazione {{headingLevel}}',
  },
  ja: {
    label: '見出し{{headingLevel}}',
  },
  ko: {
    label: '제목 {{headingLevel}}',
  },
  my: {
    label: '[SURAT]\n\nKepala {{headingLevel}}',
  },
  nb: {
    label: 'Overskrift {{headingLevel}}',
  },
  nl: {
    label: 'Kop {{headingLevel}}',
  },
  pl: {
    label: 'Nagłówek {{headingLevel}}',
  },
  pt: {
    label: 'Cabeçalho {{headingLevel}}',
  },
  ro: {
    label: 'Titlu {{headingLevel}}',
  },
  rs: {
    label: 'Наслов {{headingLevel}}',
  },
  'rs-latin': {
    label: 'Naslov {{headingLevel}}',
  },
  ru: {
    label: 'Заголовок {{headingLevel}}',
  },
  sk: {
    label: 'Nadpis {{headingLevel}}',
  },
  sl: {
    label: 'Naslov {{headingLevel}}',
  },
  sv: {
    label: 'Rubrik {{headingLevel}}',
  },
  ta: {
    label: 'தலைப்பு {{headingLevel}}',
  },
  th: {
    label: 'หัวข้อ {{headingLevel}}',
  },
  tr: {
    label: 'Başlık {{headingLevel}}',
  },
  uk: {
    label: 'Заголовок {{headingLevel}}',
  },
  vi: {
    label: 'Tiêu đề {{headingLevel}}',
  },
  zh: {
    label: '标题 {{headingLevel}}',
  },
  'zh-TW': {
    label: '標題 {{headingLevel}}',
  },
}
